exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image,.upload-img {\n  display: block;\r\n  width: 50px;\r\n  height: 50px;\r\n  border: none;\n}\n.imgBox{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100px;\n  height: 60px;\n  background: rgba(0, 0, 0, 0.1);\n  margin-top: 5px;\n}\r\n", ""]);

// exports
